import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatMenuModule} from "@angular/material/menu";
import {MatPaginatorIntl, MatPaginatorModule} from "@angular/material/paginator";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {
    MatNativeDateModule,
    MatRippleModule,
    MAT_DATE_LOCALE
} from "@angular/material/core";
import {MatSortModule} from "@angular/material/sort";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {MatDividerModule} from "@angular/material/divider";
import {StatusByLightComponent} from './components/status-by-light/status-by-light.component';
import {CustomMatPaginatorInt} from "./utils/customMatPaginator";
import { ItemDetailsComponent } from './components/item-details/item-details.component';
import {MatDrawer, MatDrawerContainer, MatSidenavModule} from "@angular/material/sidenav";
import { MaintenanceStatusbarComponent } from './components/maintenance-statusbar/maintenance-statusbar.component';
import { SignatureComponent } from './components/signature/signature.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRippleModule,
        MatSortModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        NgxMatSelectSearchModule,
        MatDividerModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRippleModule,
        MatSortModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        NgxMatSelectSearchModule,
        MatDividerModule,
        MatSidenavModule,
        StatusByLightComponent,
        ItemDetailsComponent,
        MaintenanceStatusbarComponent,
        SignatureComponent
    ],
    providers: [
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'it-IT'
        },
        {provide: MatPaginatorIntl, useValue: CustomMatPaginatorInt()}
    ],
    declarations: [
        StatusByLightComponent,
        ItemDetailsComponent,
        MaintenanceStatusbarComponent,
        SignatureComponent
    ]
})
export class SharedModule {
}
